import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Compass, ShoppingCart, Bell, User } from 'lucide-react';
import { useApp } from '../../context/AppContext';

export function MobileBottomNav() {
  const { cart, unreadCount } = useApp();
  const cartCount = cart.reduce((sum, c) => sum + c.qty, 0);
  const updates = unreadCount('consumer');
  const items = [
    { to: '/', icon: Home, label: 'Home' },
    { to: '/explore', icon: Compass, label: 'Explore' },
    { to: '/cart', icon: ShoppingCart, label: 'Cart', badge: cartCount },
    { to: '/my-kelate/notifications', icon: Bell, label: 'Updates', badge: updates },
    { to: '/my-kelate', icon: User, label: 'Me' },
  ];
  return (
    <nav data-testid="mobile-bottom-nav" className="fixed bottom-0 left-0 right-0 z-40 border-t border-kelate-line bg-kelate-surface md:hidden">
      <div className="grid grid-cols-5">
        {items.map((item) => (
          <NavLink
            key={item.label}
            to={item.to}
            end={item.to === '/'}
            data-testid={`bottomnav-${item.label.toLowerCase()}`}
            className={({ isActive }) => `relative flex flex-col items-center gap-0.5 py-2 text-[10px] ${isActive ? 'text-kelate-darkwood font-semibold' : 'text-kelate-soft'}`}
          >
            <item.icon size={18} />
            {item.label}
            {item.badge > 0 && (
              <span className="absolute right-[calc(50%-18px)] top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-kelate-red px-1 text-[9px] font-semibold text-white">
                {item.badge}
              </span>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
